/**
 * The right-click of every opened surface (focus windows, floating windows,
 * the docked chat): the item's ⋯ menu (`ItemContextMenu`). A right-click
 * whose menu has no item passes through instead of opening nothing.
 */
import { createElement } from "react";
import type { FrameChromeMenuItem } from "@/components/shapes/shared/frame-chrome-config";
import type { FrameContextMenuOwner } from "@/components/shapes/shared/frame-renderer-context";
import {
  frameMenuFacts,
  openedMenuOpens,
} from "@/components/wall/card-menu-items";
import { wallFrame } from "@/components/wall/wall-frame-source";
import type { FrameData } from "@/lib/frame-data";
import { ItemContextMenu } from "./item-menu";

/**
 * Whether the menu has an item, for the frame the wall has, else the one the
 * window shows (a fresh docked chat), as its ⋯ decides.
 */
function opens(
  frame: FrameData,
  extras: readonly FrameChromeMenuItem[],
  selection: string,
): boolean {
  const shown = wallFrame(frame.frameId) ?? frame;
  return openedMenuOpens(shown, frameMenuFacts(shown.frameId), {
    extras,
    selection,
  });
}

export const itemContextMenu: FrameContextMenuOwner = {
  opens,
  render: (props) => createElement(ItemContextMenu, props),
};
